import LoginViewModel from "@/components/screens/Login/Models/LoginViewModel";
import LoginScreen from "@/components/screens/Login/Screens/LoginScreen";
import type { ILoginViewModel } from "@/components/screens/Login/Types/LoginTypes";

const LoginPage = () => {
  const loginViewModel: ILoginViewModel = LoginViewModel();

  return <LoginScreen vm={loginViewModel} />;
};

export default LoginPage;
